module.exports = __webpack_public_path__ + "static/media/doc-5.377b8949.jpg";